import { View } from '../../primitives/View';
import { bottomSheetFooterBlurClass } from './BottomSheet.variants';

/**
 * Overlay-footer backdrop — web. Its own layer rather than a class on the
 * content box, because the blur's fade-in is a `mask-image` and a mask on the
 * box would fade the buttons along with it. See the `.native` sibling for the
 * same ramp drawn with a `MaskedView`.
 */
export function BottomSheetFooterBackground() {
  return <View className={bottomSheetFooterBlurClass} />;
}
BottomSheetFooterBackground.displayName = 'BottomSheetFooterBackground';
